import { useRecoilState, useResetRecoilState } from "recoil";
import { myTimesheetFilterCounterState } from "my-timesheet/states";

export const useMyTimesheetFilterCounterState = () => {
  const [state, setState] = useRecoilState(myTimesheetFilterCounterState);
  const resetState = useResetRecoilState(myTimesheetFilterCounterState);

  return {
    state,
    setState,
    resetState,
  };
};

export default useMyTimesheetFilterCounterState;
